import * as React from "react";
import { Divider } from "@chakra-ui/react";
import { AccordionItem, Form, TextInput, Grid } from "components";
import { useDentalChart } from "../../duck";
import { Endodontics, OralSurgery, Restoration, RootCanal } from "./components";
import { FormValues, useUpdateTreatments, getDefaultValues } from "./duck";

const Treatments: React.FC = () => {
  const dentalChart = useDentalChart();

  const defaultValues = getDefaultValues(dentalChart);

  const onChange = useUpdateTreatments(
    dentalChart?._id || null,
    dentalChart?.fakeId || null
  );

  if (!defaultValues) {
    return null;
  }

  return (
    <AccordionItem title="Treatments">
      <Form<FormValues> defaultValues={defaultValues}>
        <Form.Watcher defaultValues={defaultValues} onChange={onChange} />
        <Grid
          templateColumns={{
            base: "1fr",
            sm: "repeat(2, 1fr)"
          }}
        >
          <OralSurgery />
          <Restoration />
          <Endodontics />
        </Grid>

        <Divider my={6} h="1px" borderColor="#D0D1D3" />

        <RootCanal />

        <TextInput
          label="Additional comments and notes"
          placeholder="Enter additional comments and notes"
          name="treatmentComment"
          type="text-area"
        />
      </Form>
    </AccordionItem>
  );
};

export default Treatments;
